export default {"src":"/_next/static/media/ethIcon.3ebd6282.svg","height":18,"width":11,"blurWidth":0,"blurHeight":0};